import APIClient from '@/shared/http/clients/api'

const resourceName = 'regulationauto'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const GetBySinister = (sinister, version, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/sinister/${sinister}/version/${version}`, config)
const GetTypeBySinisterVersion = (sinister, version, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationtype/${sinister}/version/${version}`, config)
const GetSurveyWay = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}/surveyway`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)
const Search = (limit, index, data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/search?limit=${limit}&index=${index}`, data, config)
const Export = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/export`, data, config)
const Distribute = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/distribute`, data, config)
const ReturnRegulationToExpert = (id, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}/${id}/expert`, config)
const ChangeStageRegulationToDigitation = (id, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}/${id}/stage/digitation`, config)
const ChangeStageRegulationAccomplished = (id, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}/${id}/stage/accomplished`, config)
const ChangeStageRegulationCompleted = (id, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}/${id}/stage/completed`, config)

const RegulationAutoRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  GetBySinister,
  GetTypeBySinisterVersion,
  Create,
  Update,
  Delete,
  Search,
  Export,
  Distribute,
  ReturnRegulationToExpert,
  ChangeStageRegulationToDigitation,
  ChangeStageRegulationAccomplished,
  ChangeStageRegulationCompleted,
  GetSurveyWay
}

export default RegulationAutoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationauto.js